import TournamentNotification from './tournamentNotification';
import SystemNotification from './systemNotification';

export {
  TournamentNotification,
  SystemNotification
}
